'use client';

import { useRouter } from 'next/navigation';
import { TableCell, TableRow } from '@mui/material';

import {
  PlatformBadge,
  ProcessedDate,
  ProcessedName,
  StyledIdTableCell,
} from '~/shared';
import { CampaignStatus } from '~/types';

import { UseGetSponsoredProductsReturnList } from '../../hooks/useGetSponsoredProducts';
import { StatusSponsoredSelectBadge } from '../StatusSponsoredSelectBadge';

export type CampaignRowProps = {
  campaign: UseGetSponsoredProductsReturnList[number];
};

export function SponsoredCampaignRow({ campaign }: CampaignRowProps) {
  const router = useRouter();
  return (
    <TableRow
      key={campaign.name}
      sx={{
        cursor: 'pointer',
        '&:hover': {
          '.MuiTableCell-body': {
            backgroundColor: theme => theme.palette.grey[100],
          },
        },
        '.MuiTableCell-body': {
          backgroundColor: 'background.paper',
        },
      }}
    >
      <StyledIdTableCell
        component="th"
        scope="row"
        align="center"
        onClick={() => router.push(`/patrocinados/${campaign.id}`)}
      >
        {campaign.id}
      </StyledIdTableCell>
      <TableCell
        component="th"
        scope="row"
        sx={{
          position: 'sticky',
          left: 0,
        }}
        onClick={() => router.push(`/patrocinados/${campaign.id}`)}
      >
        <ProcessedName
          name={campaign.name}
          advertiserName={campaign.advertiser?.name}
        />
      </TableCell>
      <TableCell
        component="th"
        scope="row"
        onClick={() => router.push(`/patrocinados/${campaign.id}`)}
      >
        <PlatformBadge isApp={campaign.isApp} isWeb={campaign.isWeb} />
      </TableCell>
      <TableCell
        component="th"
        scope="row"
        align="center"
        onClick={() => router.push(`/patrocinados/${campaign.id}`)}
      >
        {campaign.startDate ? <ProcessedDate date={campaign.startDate} /> : '-'}
      </TableCell>
      <TableCell
        component="th"
        scope="row"
        align="center"
        onClick={() => router.push(`/patrocinados/${campaign.id}`)}
      >
        {campaign.endDate ? <ProcessedDate date={campaign.endDate} /> : '-'}
      </TableCell>

      <TableCell
        component="th"
        scope="row"
        align="center"
        onClick={() => router.push(`/patrocinados/${campaign.id}`)}
      >
        {campaign.status && (
          <StatusSponsoredSelectBadge
            campaignId={campaign.id}
            campaignStatus={
              campaign.status.toUpperCase() as `${CampaignStatus}`
            }
          />
        )}
      </TableCell>
    </TableRow>
  );
}
